/**
 * The only analytics the free RIDDOR checker sends.
 *
 * Every property is a fixed value, so the visitor's answers (what happened,
 * who was hurt, the outcome) never reach PostHog: the type allows no free
 * text, and __tests__/marketing/riddor-checker-behaviour.test.tsx checks the
 * payloads.
 */
export type RiddorCheckerEvent =
  /** The visitor answered a question for the first time on this page view. */
  | { event: "riddor_checker_used" }
  /** The visitor answered every question that applies and saw an outcome. */
  | { event: "riddor_checker_completed" };

interface Capture {
  capture?: (event: string, properties: Record<string, string>) => unknown;
}

export function trackRiddorChecker(posthog: Capture | null | undefined, analyticsEvent: RiddorCheckerEvent): void {
  posthog?.capture?.(analyticsEvent.event, { tool: "riddor_checker" });
}
